// bbCardService.ts

import { callBBCard } from './bbCardApi';
import store from '../redux/store';

interface EngagementParam {
    [key: string]: any;
}

// Function to execute callBBCard with the necessary parameters
export const executeBBCard = async (engagementParam: EngagementParam): Promise<void> => {
    const state = store.getState();
    const user = state.user;

    if (Object.keys(engagementParam).length > 0 && user.user?.bbc_id) {
        await callBBCard({ ...engagementParam, bbc_id: user.user.bbc_id });
    }
};
